const TrustedCandidateText = () => {
    return (
      <>
       <span className="inline relative">
                  Employers believe what your peers say about your skills.
                  Ratings are only of your skills. There is no rating of you as
                  a person.
                  <span id="dots"> </span>
        <span 
                    id="more"
                    className="hidden absolute z-30 left-0 
                                        bg-primary-white mt-7 p-2 pt-0 rounded-xl shadow-lg
                                        max-md:w-[111%] t-width-learnmor"
                  >
                    <strong className="block font-normal rounded-lg px-4">
                      <p>
                        <b>Employers trust peer ratings</b>
                        <br />
                        Teamanics uses peer ratings of skills to scale the
                        all-time favorite method of hiring – a personal
                        referral. Employers trust skill ratings of a candidate
                        from a group of peers as much as a personal referral.
                        <br />
                      </p>
                      <p>
                        <b>Don’t Worry – No one gets all 5 stars</b>
                        <br />
                        Employers want to know your strengths. They want the
                        right people for their jobs. They are not hoping to find
                        someone who is unbelievably great at everything.
                        <br />
                      </p>
                      <p>
                        <b>Confidential and Private</b>
                        <br />
                        Ratings are only shown to employers when you are matched
                        to a job. Peers cannot see your ratings from others.
                      </p>
                    </strong>
                  </span>
                  </span>
      </>
    );
  };
  export default TrustedCandidateText;
  